import React from "react";

const Contact = () => (
  <div className="flex flex-col items-center justify-center h-screen">
    <h1 className="text-4xl font-bold mb-4">Contact Us</h1>
    <p className="text-lg">Coming Soon</p>
  </div>
);

export default Contact;
